import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog__header flex flex-column" }
const _hoisted_2 = ["textContent"]

import { Ref, ref, toRefs, onMounted, onUnmounted, watch } from 'vue';
import Column from 'primevue/column';
import DataTable, { DataTableFilterMeta } from 'primevue/datatable';
import { FilterMatchMode } from 'primevue/api';
import Dialog from 'primevue/dialog';
import { EMIT } from '@/enum';

interface AddItemsInterface {
  name: string;
  value: number;
}

interface AddPersonPropsInterface {
  items?: AddItemsInterface[] | [];
  title: string;
  className?: string;
  listHeaderText?: string;
  buttonText?: string;
  searchable?: boolean;
  searchProperty?: string;
  loading?: boolean;
  placeholder?: string;
  personType?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddPersonModal',
  props: {
    items: { default: undefined },
    title: {},
    className: { default: undefined },
    listHeaderText: { default: 'Name' },
    buttonText: { default: undefined },
    searchable: { type: Boolean },
    searchProperty: { default: undefined },
    loading: { type: Boolean, default: false },
    placeholder: { default: 'enter search term' },
    personType: { default: 'people' }
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { items, personType, placeholder, listHeaderText, loading } = toRefs(props);
const selectedItems = ref([]);
const scrollComponent = ref();
const modalVisible = ref(true);

onMounted(() => {
  setTimeout(() => {
    let content = document.getElementsByClassName('p-dialog-content');
    if (content.length) scrollComponent.value = content[0];
  }, 100);
});

onUnmounted(() => {
  stopScrollListener();
});

const stopScrollListener = () => {
  if (scrollComponent.value) scrollComponent.value.removeEventListener('scroll', handleScroll);
};

const startScrollListener = () => {
  if (scrollComponent.value) scrollComponent.value.addEventListener('scroll', handleScroll);
};

const handleScroll = () => {
  const element = scrollComponent.value;
  if (element.scrollTop >= element.scrollHeight - element.offsetHeight - 20) {
    //stop listening so it doesnt keep hitting the DB
    stopScrollListener();
    emit(EMIT.LOAD_MORE_ITEMS);
  }
};

/**
 * when the items list increases then start listening again for scroll
 */
watch(items, startScrollListener);

const addItems = (): void => {
  emit(EMIT.ADD_ITEMS, selectedItems.value);
  selectedItems.value = [];
  modalVisible.value = false;
};

const cancel = (): void => {
  emit(EMIT.CANCEL);
  selectedItems.value = [];
  modalVisible.value = false;
};

const onSearch = () => (selectedItems.value = []);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const filter: Ref<any> = ref({
  global: { value: '', matchMode: FilterMatchMode.CONTAINS },
  name: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
} as DataTableFilterMeta);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((modalVisible).value = $event)),
    draggable: false,
    modal: true,
    class: "dialog__container",
    onHide: cancel
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", {
          class: "mb-3",
          textContent: _toDisplayString(props.title)
        }, null, 8, _hoisted_2),
        (props.searchable)
          ? (_openBlock(), _createBlock(_component_IconField, {
              key: 0,
              "icon-position": "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InputIcon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      name: "search",
                      class: "text-lg"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_InputText, {
                  modelValue: filter.value.global.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter.value.global.value) = $event)),
                  placeholder: _unref(placeholder),
                  class: "p-inputtext-sm",
                  onInput: onSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        text: "Cancel",
        type: "secondary",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        disabled: !selectedItems.value.length || !_unref(items)?.length,
        text: __props.buttonText,
        type: "primary",
        onClick: addItems
      }, null, 8, ["disabled", "text"])
    ]),
    default: _withCtx(() => [
      (_unref(loading))
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            class: "flex justify-content-center align-items-center h-full loader"
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(DataTable), {
        filters: filter.value,
        "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((filter).value = $event)),
        selection: selectedItems.value,
        "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((selectedItems).value = $event)),
        "global-filter-fields": ['name'],
        scrollable: true,
        value: _unref(items),
        "virtual-scroller-options": { itemSize: 52 },
        "data-key": "value",
        "responsive-layout": "scroll",
        "scroll-height": "500px",
        "table-style": "min-width: 30rem"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(!_unref(loading) ? `No ${_unref(personType)} to be added` : `Loading ${_unref(personType)} to be added`), 1)
        ]),
        default: _withCtx(() => [
          (_unref(items)?.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(Column), {
                  "body-style": "max-width: 3rem",
                  "header-style": "max-width: 3rem",
                  "selection-mode": "multiple"
                }),
                _createVNode(_unref(Column), {
                  header: _unref(listHeaderText),
                  field: "name",
                  sortable: ""
                }, null, 8, ["header"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["filters", "selection", "value"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})